import { useMemo } from 'react'

/**
 * Transform hierarchy data into react-d3-tree format
 * react-d3-tree expects: { name: string, children: [] }
 * 
 * Strategy: Create a flat structure where:
 * - Main person is the node
 * - Partners are stored in attributes (rendered separately via custom node)
 * - Children are actual children in the tree
 */
export const useD3TreeData = (hierarchy) => {
    return useMemo(() => {
        if (!hierarchy || hierarchy.length === 0) {
            return null
        }

        const rootNode = hierarchy[0]

        /**
         * Transform a hierarchy node to react-d3-tree format
         */
        const transformNode = (node) => {
            if (!node) return null

            const treeNode = {
                name: node.display_name || 'Unnamed',
                attributes: {
                    id: node.id,
                    leafId: node.id,
                    display_name: node.display_name,
                    claimed_by: node.claimed_by,
                    relationship: node.relationship,
                    // Store partners in attributes for custom rendering
                    partners: node.partners || [],
                },
                children: [],
            }

            // Handle children - transform recursively
            if (node.children && node.children.length > 0) {
                treeNode.children = node.children
                    .map((child) => transformNode(child))
                    .filter((child) => child !== null)
            }

            return treeNode
        }

        return transformNode(rootNode)
    }, [hierarchy])
}

export default useD3TreeData
